module.exports = __webpack_public_path__ + "f4551d7c463541d0d4b7f95cdbcc7913.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-SemiBold.woff
 ** module id = 1228
 ** module chunks = 9
 **/